import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoComplete from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import courseType from 'src/types/responses/course';
import Api from '@/services/api/ApiServiceFabrick';
import { ref, computed, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CourseAutoComplete',
  props: {
    modelValue: {},
    operationOfficeId: {},
    initialId: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const courses = ref<courseType[]>([]);
const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

onMounted(() => {
  Api()
    .getCourses(props.operationOfficeId)
    .then((data: courseType[]) => {
      courses.value = data;
      if (props.initialId) {
        const foundCourse = courses.value.find((course: courseType) => {
          return course.id === props.initialId;
        });
        if (foundCourse) {
          modelValue.value = foundCourse;
        }
      }
    });
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoComplete, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: props.label,
    itemName: "name",
    items: courses.value
  }, null, 8, ["modelValue", "label", "items"]))
}
}

})